import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--bg)',
    animation: 'fadeUp 0.6s ease both',
  },
  card: {
    textAlign: 'center',
    padding: '3rem 2.5rem',
    maxWidth: '360px',
    width: '100%',
  },
  logo: {
    fontFamily: 'var(--font-display)',
    fontSize: '32px',
    fontWeight: 300,
    fontStyle: 'italic',
    color: 'var(--accent)',
    letterSpacing: '-0.01em',
    marginBottom: '6px',
  },
  tagline: {
    fontSize: '12px',
    color: 'var(--text-tertiary)',
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    marginBottom: '3rem',
  },
  divider: {
    width: '32px',
    height: '1px',
    background: 'var(--border)',
    margin: '0 auto 3rem',
  },
  btn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    width: '100%',
    padding: '12px 20px',
    background: 'var(--bg-card)',
    border: '0.5px solid var(--border)',
    borderRadius: 'var(--radius)',
    color: 'var(--text-primary)',
    fontSize: '13px',
    cursor: 'pointer',
    transition: 'border-color 0.2s, background 0.2s',
    letterSpacing: '0.02em',
  },
  footer: {
    marginTop: '2.5rem',
    fontSize: '11px',
    color: 'var(--text-tertiary)',
    lineHeight: 1.6,
  },
};

function GoogleIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
  );
}

export default function LoginPage({ onLogin }) {
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        });
        const profile = await res.json();
        onLogin({
          name: profile.name,
          email: profile.email,
          picture: profile.picture,
          sub: profile.sub,
        }, tokenResponse.access_token);
      } catch (err) {
        console.error('Failed to fetch user info', err);
      }
    },
    onError: () => console.error('Google login failed'),
    scope: 'openid email profile https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/tasks',
  });

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>decodification</div>
        <div style={styles.tagline}>your productivity space</div>
        <div style={styles.divider} />
        <button
          style={styles.btn}
          onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--border-hover)'; e.currentTarget.style.background = 'var(--bg-hover)'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.background = 'var(--bg-card)'; }}
          onClick={() => login()}
        >
          <GoogleIcon />
          Continue with Google
        </button>
        <div style={styles.footer}>
          Sign in to access your personal dashboard.<br />
          Your data stays on your device.
        </div>
      </div>
    </div>
  );
}
